import { ControlsOf, FormGroupType } from '@app/core/utils/formgroup-type';
import { MeteringPointsMeterCharacteristic } from '@app/api/dmc';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createDetailMeterCharacteristicsForm(): FormGroupType<MeteringPointsMeterCharacteristic> {
  return new FormGroup<ControlsOf<MeteringPointsMeterCharacteristic>>({
    identification: new FormControl<string | null>(null, Validators.required),
    numberOfDigits: new FormControl(null, [Validators.required, Validators.min(1)]),
    unitType: new FormControl(null, Validators.required),
    meterReadingType: new FormControl(null, Validators.required),
  });
}
